import React from 'react'

const LimitPage = () => {
  return (
    <div>LimitPage</div>
  )
}

export default LimitPage